import { Link } from 'react-router-dom';
import { MessageCircle, ArrowRight } from 'lucide-react';
import { Section, SectionHeader, CtaLink, ProductFrame } from '../shared/blocks';
import { BRAND, ERP_MODULES } from '../content';

export function SchoolSection() {
  return (
    <Section id="for-schools" tone="muted" data-testid="school-management-section">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <SectionHeader eyebrow="For schools" title="One platform for teaching and school management." subtitle="AI tools for every teacher. A complete school ERP for administrators. One login." />
          <ul className="grid grid-cols-2 sm:grid-cols-3 gap-3 -mt-4" aria-label="School ERP modules">
            {ERP_MODULES.map(({ id, name, icon: Icon }) => (
              <li key={id} className="flex items-center gap-2.5 rounded-xl border border-mk-line dark:border-mk-edge bg-white dark:bg-mk-navy px-3.5 py-3 text-sm font-medium text-mk-ink dark:text-slate-200">
                <Icon className="h-4 w-4 text-mk-blue shrink-0" aria-hidden="true" /> {name}
              </li>
            ))}
          </ul>
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <CtaLink to="/contact" arrow testid="school-enquiry-cta">Enquire for your school</CtaLink>
            <CtaLink href={BRAND.whatsappLink('Hi! I would like to know more about ActanonEdu for my school.')} variant="secondary" testid="school-whatsapp-btn">
              <MessageCircle className="h-4 w-4" aria-hidden="true" /> WhatsApp us
            </CtaLink>
          </div>
          <div className="mt-6 flex flex-wrap gap-x-6 gap-y-2 text-sm">
            <Link to="/school-erp" className="inline-flex items-center gap-1 font-semibold text-mk-deep dark:text-mk-cyan hover:underline" data-testid="home-erp-explore">Explore the School ERP <ArrowRight className="h-3.5 w-3.5" aria-hidden="true" /></Link>
            <Link to="/school-pilot-program" className="inline-flex items-center gap-1 font-semibold text-mk-deep dark:text-mk-cyan hover:underline" data-testid="home-pilot-learn">30-day school pilot <ArrowRight className="h-3.5 w-3.5" aria-hidden="true" /></Link>
          </div>
        </div>
        <ProductFrame src="/product/school-students.webp" alt="ActanonEdu student records with class, attendance and status" label="School ERP · Students" />
      </div>
    </Section>
  );
}
